import app from './modules/app'
// import cs from './vuexStore'
import { createStore } from "vuex";
const store = createStore({
  modules: {
    app,
    // cs
  }
})
export default store